export default __webpack_public_path__ + "static/SRUS P600 - Product Specifications & Technical Data-21c026158ada5de9839e38c79d88ee26.pdf";